export default __webpack_public_path__ + "static/media/100.5a242955.jpg";